// id - cetagory number
const catergoryList = [
  {
    id: 1,
    title: "Alertness",
    iconName: "alertness_icon.png",
  },
  {
    id: 2,
    title: "Attitude",
    iconName: "Attitude_icon.png",
  },
  {
    id: 3,
    title: "Essential documents",
    iconName: "contract.png",
  },
  {
    id: 4,
    title: "Hazard awareness",
    iconName: "alarm.png",
  },
  {
    id: 5,
    title: "Road and traffic signs",
    iconName: "traffic_light.png",
  },
  {
    id: 6,
    title: "Incidents, accidents and emergencies ",
    iconName: "car_collision.png",
  },
  {
    id: 7,
    title: "Other types of vehicle",
    iconName: "electric_scooter.png",
  },
  {
    id: 8,
    title: "Vehicle handling",
    iconName: "steering_wheel.png",
  },
  {
    id: 9,
    title: "Motorway rules",
    iconName: "motorway.png",
  },
  {
    id: 10,
    title: "Rules of the road",
    iconName: "rules_book.png",
  },
  {
    id: 11,
    title: "Safety margins",
    iconName: "car_icon.png",
  },
  {
    id: 12,
    title: "Safety and your vehicle",
    iconName: "icons_car_service.png",
  },
  {
    id: 13,
    title: "Vulnerable road users",
    iconName: "crossing.png",
  },
];

export default catergoryList;
